// Copyright (c) 2024 IOTA Stiftung
// SPDX-License-Identifier: Apache-2.0

import { IotaLogoWeb } from '@iota/apps-ui-icons';

export function ThemedIotaLogo(): React.JSX.Element {
    return (
        <IotaLogoWeb
            className="text-iota-neutral-10 dark:text-iota-neutral-92"
            width={137}
            height={36}
        />
    );
}
